import { round, toEuros } from "@/utils/numberUtils";
import { Transform, Type } from "class-transformer";
import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { DossierDto } from "@/core/features/dossiers/dtos/dossier.dto";

export class DossierEconomicAnalysisDto extends BaseEntityDto {
  @Transform(({ value }) => toEuros(value))
  budget: number;

  @Transform(({ value }) => toEuros(value))
  totalCost: number;

  @Transform(({ value }) => toEuros(value))
  certificatedTotal: number;

  @Type(() => DossierDto)
  dossier: DossierDto;
  dossierId: string;

  getPercentage(): number {
    if (!this.totalCost) return 0;
    return round((this.totalCost / this.certificatedTotal) * 100);
  }

  getProfitabilityPercentage(): number {
    const profitability = this.getProfitability();
    if (!this.certificatedTotal || !profitability) return 0;

    return round((profitability / this.certificatedTotal) * 100);
  }

  getProfitability(): number {
    if (!this.certificatedTotal) return 0;
    return this.certificatedTotal - this.totalCost;
  }
}
